export enum NumericDBType {
  Float = 0,
  Decimal = 1,
  Int = 2,
}
